import {
  THRESHOLDS_INDEX_REQUESTED,
  THRESHOLDS_INDEX_SUCCESS,
  THRESHOLDS_INDEX_FAILURE,
  THRESHOLDS_CREATE_REQUESTED,
  THRESHOLDS_CREATE_SUCCESS,
  THRESHOLDS_CREATE_FAILURE,
  THRESHOLDS_UPDATE_REQUESTED,
  THRESHOLDS_UPDATE_SUCCESS,
  THRESHOLDS_UPDATE_FAILURE,
  THRESHOLDS_DELETE_REQUESTED,
  THRESHOLDS_DELETE_SUCCESS,
  THRESHOLDS_DELETE_FAILURE,
  THRESHOLDS_BY_ITEM_REQUESTED,
  THRESHOLDS_BY_ITEM_SUCCESS,
  RESET_THRESHOLDS_STATE,
  UPLOAD_TOKEN_REQUESTED,
  UPLOAD_TOKEN_SUCCESS,
  THRESHOLDS_CSV_UPLOAD_REQUESTED,
  THRESHOLDS_CSV_UPLOAD_SUCCESS,
  THRESHOLDS_CSV_UPLOAD_FAILURE,
  THRESHOLDS_CSV_PROCESS_REQUESTED,
  THRESHOLDS_CSV_PROCESS_SUCCESS,
  THRESHOLDS_CSV_PROCESS_FAILURE,
  // THRESHOLD_CREATE_REQUESTED,
  // THRESHOLD_CREATE_SUCCESS,
  // THRESHOLD_CREATE_FAILURE,
  SEARCH_PRODUCT_REQUESTED,
  GET_ASSIGNMENT_THRESHOLDS_REQUESTED,
  GET_ASSIGNMENT_THRESHOLDS_SUCCESS,
  GET_ASSIGNMENT_THRESHOLDS_FAILURE,
} from '../types';


const INITIAL_STATE = {
  thresholds: [],
  relatedProducts: {},
  updatingThresholds: [],
  itemSearchingThresholds: [],
  itemThresholds: {},
  thresholdsSearchStack: [''],
  lastPage: true,
  newThresholdsMessage: null,
  isFetching: false,
  status: 'waiting',
  uploadStatus: 'waiting',
  searchingAssignmentLocationThresholds: [],
  assignmentLocationThresholds: {},
  errors: null
};

const thresholds = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case THRESHOLDS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        thresholds: [],
        relatedProducts: {},
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case THRESHOLDS_INDEX_SUCCESS:
      newState.thresholds = (action.payload.thresholds || []);
      newState.relatedProducts = (action.payload.related_product_data || {});
      newState.isFetching = false;
      newState.status = 'success';
      newState.errors = null;
      newState.lastPage = action.payload.last_page;
      if(action.payload.continuation_token !== null) {
        newState.thresholdsSearchStack[action.page] = action.payload.continuation_token;
      }
      
      return newState;

    case THRESHOLDS_INDEX_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        status: 'error',
        errors: action.error
      });


    // case threshold_CREATE_REQUESTED:
    case THRESHOLDS_CREATE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        status: 'requested',
        newThresholdsMessage: null,
        errors: null
      });

    case THRESHOLDS_CREATE_SUCCESS:
      return Object.assign({}, state, {
        newThresholdsMessage: action.payload.message,
        isFetching: false,
        status: 'created',
        errors: null
      });

    // case threshold_CREATE_SUCCESS:
    //   newState.status = 'success';
    //   newState.isFetching = false;
    //   return newState;

    // case threshold_CREATE_FAILURE:
    case THRESHOLDS_CREATE_FAILURE:
      return Object.assign({}, state, {
        thresholds: {},
        isFetching: false,
        status: 'error',
        errors: action.error
      });





    case THRESHOLDS_UPDATE_REQUESTED:
      newState.updatingThresholds.push(action.thresholdId);
      newState.errors = null;
      return newState;

    case THRESHOLDS_UPDATE_SUCCESS:
      newState.updatingThresholds = newState.updatingThresholds.filter(thresholdId => thresholdId !== action.thresholdId);
      let toUpdate = newState.thresholds.findIndex((threshold) => threshold?.product_id === action.response.product_id && threshold.variant_id === action.response.variant_id);

      if(toUpdate > -1) {
        newState.thresholds[toUpdate]['target_inventory'] = action.response['target_inventory'];
        newState.thresholds[toUpdate]['low_inventory'] = action.response['low_inventory'];
        newState.thresholds[toUpdate]['critical_inventory'] = action.response['critical_inventory'];
      } else {

        // From thresholds
        if(newState.itemThresholds[action.thresholdId]) {
          let body = {target_inventory: action.response.target_inventory, critical_inventory: action.response.critical_inventory, low_inventory: action.response.low_inventory}
          // let supplierKey = `Supplier-${action.response.supplier_id}`;
          let target = newState.itemThresholds[action.thresholdId];
          target.target_inventory = body.target_inventory;
          target.low_inventory = body.low_inventory;
          target.critical_inventory = body.critical_inventory;
        }
      }

      return newState;

    case THRESHOLDS_UPDATE_FAILURE:
      newState.updatingThresholds.filter(thresholdId => thresholdId !== action.thresholdId);
      newState.errors = 'Failed to update threshold';
      return newState


    case THRESHOLDS_DELETE_REQUESTED:
      newState.updatingThresholds.push(action.thresholdId);
      newState.errors = null;
      return newState;

    case THRESHOLDS_DELETE_SUCCESS:
      newState.updatingThresholds = newState.updatingThresholds.filter(thresholdId => thresholdId !== action.thresholdId);

      let toDelete = newState.thresholds.findIndex((threshold) => threshold?.product_id === action.response['data'].product_id && threshold.variant_id === action.response['data'].variant_id);

      if(toDelete > -1) {
        delete newState.thresholds[toDelete];
        newState.thresholds.filter(n => n);
      }


      newState.itemThresholds = { ...newState.itemThresholds };
      delete newState.itemThresholds[action.thresholdId];

      return newState;

    case THRESHOLDS_DELETE_FAILURE:
      newState.errors = 'Failed to delete threshold';
      return newState


    case THRESHOLDS_BY_ITEM_REQUESTED:
      return Object.assign({}, state, {
        itemSearchingThresholds: [...state.itemSearchingThresholds, action.itemKey]
      });

    case THRESHOLDS_BY_ITEM_SUCCESS:
      newState.itemSearchingThresholds = newState.itemSearchingThresholds.filter(item => item !== action.itemKey);
      if(action.response.thresholds) { newState.itemThresholds[action.itemKey] = (action.response.thresholds); }
      return newState;

    case GET_ASSIGNMENT_THRESHOLDS_REQUESTED:
      return Object.assign({}, state, {
        searchingAssignmentLocationThresholds: [...state.searchingAssignmentLocationThresholds, action.itemKey]
      });

    case GET_ASSIGNMENT_THRESHOLDS_SUCCESS:
      newState.searchingAssignmentLocationThresholds = newState.searchingAssignmentLocationThresholds.filter(item => item !== action.itemKey);
      if(action.response.thresholds) { newState.assignmentLocationThresholds[action.itemKey] = (action.response.thresholds); }
      return newState;



    case SEARCH_PRODUCT_REQUESTED:
      newState.itemSearchingThresholds = [];
      newState.itemThresholds = {};
      return newState;


    case RESET_THRESHOLDS_STATE:
      newState.thresholdsSearchStack = [''];
      newState.thresholds = [];
      newState.relatedProducts = {} ;
      newState.updatingThresholds = [];
      newState.itemSearchingThresholds = [];
      newState.itemThresholds = {};
      newState.lastPage = true;
      newState.newThresholdsMessage = null;
      newState.isFetching = false;
      newState.status = 'waiting';
      newState.errors = null;
      return newState;


    case THRESHOLDS_CSV_UPLOAD_REQUESTED:
      newState.uploadStatus = 'uploading';
      return newState;

    case THRESHOLDS_CSV_UPLOAD_SUCCESS:
      newState.uploadStatus = 'uploaded';
      return newState;

    case THRESHOLDS_CSV_PROCESS_REQUESTED:
      newState.uploadStatus = 'processing_requested';
      return newState;

    case THRESHOLDS_CSV_PROCESS_SUCCESS:
      newState.uploadStatus = 'processing';
      return newState;

    case THRESHOLDS_CSV_UPLOAD_FAILURE:
    case THRESHOLDS_CSV_PROCESS_FAILURE:
      newState.uploadStatus = 'failure';
      return newState;



    default:
      return state;
  }
}

export default thresholds;
